module.exports = __webpack_public_path__ + "static/media/cash-bottle.aba27184.webp";